import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useStripe } from '@stripe/react-stripe-js';
import { Typography } from '@material-ui/core';

import { Loading } from 'components';
import { CREATE_BILLING_SESSION } from 'graphql/billing';

const StripeBillingRedirect: React.FC = () => {
  const { loading, error, data } = useQuery(CREATE_BILLING_SESSION);
  const stripe = useStripe();

  React.useEffect(() => {
    if (!data || !data.createBillingSession) return;
    const { url } = data.createBillingSession;
    if (url) window.location.href = url;
  }, [data, stripe]);

  if (loading) return <Loading message="Creating billing session" />;
  if (error) return <Typography variant="h4">Error getting session: {error}</Typography>;

  return <Loading message="Redirecting you to stripe billing..." />;
};

export default StripeBillingRedirect;
